const AuroraProduct = (function () {
  const settings = {
    name: "aurora-product.js",
    debugging: true,
  };

  let elements = {
    button: {
      addToCart: document.querySelectorAll("button.js--add-to-cart-product") || [],
      variantOption: document.querySelectorAll("button.js--product-variant-option") || [],
    },
  };

  const selectors = {
    button: {
      addToCart: ".js--add-to-cart-product",
      variantOption: ".js--product-variant-option",
    },
    input: {
      variantID: "input[name='id']",
      variantQuantity: "input[name='quantity']",
      variantGrammage: "input[name='properties[_dce_grammage]']",
    },
  };

  const nonCannabisProductTypes = ["Merchandise", "Accessories"];
  let hasDelegatedProductClickListener = false;

  const addProductToCartFromButton = async function (variantButton = {}, atcButton = {}) {
    const variant = variantFactoryFromElement(variantButton);
    await AuroraServices.addProductsToCart([variant], () => AuroraRender.setButtonState(atcButton, "enabled"));
  };

  /**
   * Creates a variant object from DOM element attributes.
   *
   * Extracts variant ID, quantity, and custom properties (critical for downstream services) from data
   * attributes attached to a DOM element. Handles JSON parsing of custom properties with error handling,
   * console warning and fallback to empty object.
   * 
   * @param {HTMLElement} element - The DOM element containing the variant details.
   * @returns {object} The variant object with id, quantity and custom properties.
   * @returns {number} returns.id - The variant ID parsed from data-variant-id attribute.
   * @returns {number} returns.quantity - The quantity parsed from data-variant-quantity attribute.
   * @returns {object} returns.properties - The custom properties object parsed from data-variant-properties JSON attribute.
   *
   * @author Brenden Mersey
   */
  const variantFactoryFromElement = function (element = {}) {
    const id = parseInt(element?.getAttribute("data-variant-id") || 0);
    const quantity = parseInt(element?.getAttribute("data-variant-quantity") || 1);
    const propertiesString = element?.getAttribute("data-properties") || "{}";

    let properties = {};

    try { 
      properties = JSON.parse(propertiesString);
    } catch (error) {
      console.warn("[ AuroraProduct.variantFactoryFromElement() ] Failed to parse data-properties...", {
        element,
        invalidJSON: propertiesString,
        error,
      });
      properties = {};
    }

    return {
      id,
      quantity,
      properties,
    };
  };

  const variantFactoryFromForm = function (form = {}) {
    const id = parseInt(form.querySelector("input[name='id']")?.value || 0);
    const quantity = parseInt(form.querySelector("input[name='quantity']")?.value || 0);
    const properties = variantPropertiesFactoryFromForm(form);

    return {
      id,
      quantity,
      properties,
    };
  };

  const variantPropertiesFactoryFromForm = function (form = {}) {
    const properties = {};
    (form.querySelectorAll("input[name^='properties']") || []).forEach((prop) => {
      const propKey = prop.name.replace("properties[", "").replace("]", "");
      const propVal = prop.value;
      console.log("propKey", propKey);
      console.log("propVal", propVal);
      properties[propKey] = propVal;
    });
    return properties;
  };

  const isCannabisProduct = function ({ product_type }) {
    return nonCannabisProductTypes.some((type) => type === product_type) ? false : true;
  };

  const onClickAddSelectedVariantToCart = function (event) {
    const clickedElement = event?.target;
    if (!(clickedElement instanceof Element)) return false;

    const atcButton = clickedElement.closest(selectors.button.addToCart);
    if (!atcButton) return false;
    if (atcButton.disabled) return true;

    const product = atcButton.closest(".product");
    if (!product) return true;

    const selectedVariantButton = product.querySelector(".button--variant-option.selected");
    if (selectedVariantButton) {
      AuroraRender.setButtonState(atcButton, "disabled");
      addProductToCartFromButton(selectedVariantButton, atcButton);
    } else {
      console.log("[ onClickAddSelectedVariantToCart() ] Error :: No 'selected' variant button exists");
    }

    return true;
  };

  const onClickSelectProductVariant = function (event) {
    const clickedElement = event?.target;
    if (!(clickedElement instanceof Element)) return false;

    const button = clickedElement.closest(selectors.button.variantOption);
    if (!button) return false;

    updateSelectedVariantButtonState(button);
    updateAddToWishlistVariant(button);
    AuroraRender.productPriceFromButton(button);
    AuroraRender.productDceFromButton(button);

    return true;
  };

  const onClickProductButton = function (event) {
    if (event.defaultPrevented) return;
    if (onClickSelectProductVariant(event)) return;
    onClickAddSelectedVariantToCart(event);
  };

  const bindDelegatedProductEvents = function () {
    if (hasDelegatedProductClickListener) return;
    document.addEventListener("click", onClickProductButton);
    hasDelegatedProductClickListener = true;
  };

  const updateAddToWishlistVariant = (selectedButton) => {
    if (!selectedButton) return;

    const variantIdAttr = selectedButton.getAttribute("data-variant-id");
    const productIdAttr = selectedButton.getAttribute("data-product-id");
    if (!variantIdAttr) return;

    const variantId = Number(variantIdAttr);
    if (!variantId) return;

    const productTemplate = selectedButton.closest(".product");
    const isPDP = productTemplate?.classList?.contains("card-product") ? false : true;

    if (isPDP) {
      const productForm = selectedButton.closest(".product-cannabis__form");
      const addToWishlistButton = productForm.querySelector(".swym-add-to-wishlist");

      if (!addToWishlistButton) return;
      addToWishlistButton.setAttribute("data-variant-id", String(variantId));

      if (typeof window.triggerSwymVariantEvent === "function") {
        window.triggerSwymVariantEvent(variantId);
        console.log("triggering change");
        return;
      }
      if (window._swat?.evtLayer && window._swat?.JSEvents?.variantChanged) {
        const evt = new CustomEvent(window._swat.JSEvents.variantChanged, {
          detail: { d: { variant: { id: variantId } } }
        });
        window._swat.evtLayer.dispatchEvent(evt);
      }

      return;
    }
  };

  const updateSelectedVariantButtonState = function (selectedButton = {}) {
    if (!selectedButton?.form) return;
    (selectedButton.form.querySelectorAll(".button--variant-option") || []).forEach((variantOptionButton) => {
      variantOptionButton.classList.remove("selected");
    });
    selectedButton.classList.add("selected");
  };

  const init = async function () {
    if (settings.debugging) console.log(`${settings.name} :: Start`);

    // LOGIC FOR PULLING JS DYNAMIC ELEMENTS FROM 'QUERYSELCTALL' WHICH NEEDED FOR HTLM TO UNDERSTAND WHERE THE NEW PRODUCTS
    // ARE COMING FROM 'QUERYSELCTALL' AND THIS WILL ALLOW FOR EVENT HANDLING OF CLICKED PRODUCTS FROM LINES 7 TO 14
    elements = {
      button: {
        addToCart: document.querySelectorAll("button.js--add-to-cart-product") || [],
        variantOption: document.querySelectorAll("button.js--product-variant-option") || [],
      },
    };

    bindDelegatedProductEvents();

    if (settings.debugging) console.log(`${settings.name} :: Complete`);
  };

  return {
    init,
    isCannabisProduct,
    variantFactoryFromElement,
    variantFactoryFromForm,
    elements,
    selectors,
    settings,
  };
})();
